import React from 'react'
import './Copyright.css'

const Copyright = () => {
  return (
    <div className='container'>
        <div>
           <p> Copyright © 2022 All rights reserved | MADE BY 🍁 Web developer oliva.</p>
        </div>
    </div>
  )
}

export default Copyright 